import classNames from "classnames";
import { Col, Row } from "react-grid-system";
import { GetAccountResponse } from "../../lib/api/models";
import { useGetStatementHistory } from "../../lib/api/queries";
import { ToolType } from "../AccountDetails";
import { toolTypeToName } from "../AccountDetails/utils";
import StyledError from "../common/StyledError";
import Container from "../common/Container";
import Spinner from "../common/Spinner";
import StyledButton from "../common/buttons/StyledButton";
import toolStyles from "../../sharedStyles/Tool.module.css";
import StatementHistoryTable from "./StatementHistoryTable";

const strings = {
  close: "Close",
  errorTitle: "Failed to load Statement History",
};

type Props = {
  className?: string;
  toolId: string;
  onRequestClose: () => void;
  account: GetAccountResponse;
};

export default function StatementHistory({
  className,
  toolId,
  onRequestClose,
  account,
}: Props) {
  const {
    data: getStatementHistoryResponse,
    isLoading: isGetStatementHistoryResponseLoading,
    isError: isGetStatementHistoryResponseError,
    error: getStatementHistoryResponseError,
    refetch: getStatementHistoryResponseRefetch,
    isRefetching: isGetStatementHistoryResponseRefetching,
  } = useGetStatementHistory(account.currentDwbuid);

  return (
    <div className={classNames(toolStyles.container, className)} id={toolId}>
      <Container>
        <Row className={toolStyles.header}>
          <Col md={11} className={toolStyles.centerCol}>
            <h2 className={toolStyles.title}>
              {toolTypeToName(ToolType.StatementHistory)}
            </h2>
          </Col>
          <Col md={1} className={toolStyles.centerCol}>
            <StyledButton
              className={toolStyles.headerButton}
              variant="secondary"
              onClick={onRequestClose}
            >
              {strings.close}
            </StyledButton>
          </Col>
        </Row>
        {isGetStatementHistoryResponseLoading ||
        isGetStatementHistoryResponseRefetching ? (
          <Row>
            <Col>
              <Spinner />
            </Col>
          </Row>
        ) : isGetStatementHistoryResponseError ? (
          <Row>
            <Col>
              <StyledError
                errorTitle={strings.errorTitle}
                error={getStatementHistoryResponseError}
                refetch={getStatementHistoryResponseRefetch}
              />
            </Col>
          </Row>
        ) : (
          <Row>
            <Col>
              <StatementHistoryTable
                statements={getStatementHistoryResponse.statements}
              />
            </Col>
          </Row>
        )}
      </Container>
    </div>
  );
}
